<div class="page-container trade-review-container container pb-3">
  <app-breadcrumb [crumbConfig]="crumbConfig" />

  @if (tradeId === '') {
    <app-rb-grid
      [gridConfig]="gridConfig"
      [getSetup]="getGridSetup"
      [getData]="getGridData"
    />
  } @else {
    <app-trade-review-detail [tradeId]="tradeId" />
  }
</div>
